import { RegionsEnum } from 'src/generated/operations';
import { ActuatorTypes } from 'src/actuators/user-input/calculations/constants';
import { handleManual } from 'src/actuators/user-input/calculations/handleManual';
import { DamperType, UserInput } from 'src/actuators/user-input/types';
import { handleRoundEuNonLinear } from 'src/actuators/user-input/calculations/caseOne';
import { handleRoundAm } from 'src/actuators/user-input/calculations/roundAm';
import { handleSquareEu } from 'src/actuators/user-input/calculations/caseTwo';
import { handleRectangularAm } from 'src/actuators/user-input/calculations/rectangularAm';
import { ActuatorsAppUserInputPageData } from 'src/actuators/user-input/userInputPageMapping';

type Args = {
    inputState: UserInput;
    data?: ActuatorsAppUserInputPageData;
    searchParams: URLSearchParams;
    selectedActuatorType: ActuatorTypes;
    currentRegion: RegionsEnum;
}

export const calculateUserInputResult = (
    {
        inputState,
        data,
        searchParams,
        selectedActuatorType,
        currentRegion,
    }: Args,
) => {
    const newState = { ...inputState };

    if (newState.force !== null) {
        newState.result = '';
        if (data !== undefined && data !== null) {
            handleManual(
                selectedActuatorType === ActuatorTypes.Linear ? data.ActuatingForce : data.Torque,
                searchParams,
                newState,
                selectedActuatorType,
                currentRegion,
            );
        }
    } else {
        if (currentRegion !== RegionsEnum.Am && newState.damper === DamperType.Round) {
            newState.result = handleRoundEuNonLinear(searchParams, newState, selectedActuatorType);
        }

        if (currentRegion === RegionsEnum.Am &&
                newState.damper === DamperType.Round &&
                data !== undefined &&
                data !== null
        ) {
            newState.result = handleRoundAm(
                selectedActuatorType === ActuatorTypes.Linear ? data.ActuatingForce : data.Torque,
                searchParams,
                newState,
                selectedActuatorType,
            );
        }

        if (newState.damper === DamperType.Rectangular &&
                data !== undefined &&
                data !== null
        ) {
            if (currentRegion !== RegionsEnum.Am) {
                newState.result = handleSquareEu(
                    selectedActuatorType === ActuatorTypes.Linear ? data.ActuatingForce : data.Torque,
                    searchParams,
                    newState,
                    selectedActuatorType,
                );
            } else {
                newState.result = handleRectangularAm(
                    selectedActuatorType === ActuatorTypes.Linear ? data.ActuatingForce : data.Torque,
                    searchParams,
                    newState,
                    selectedActuatorType,
                );
            }
        }
    }

    return newState;
};
